const LinkBankAccount = ({ location: { pathname, search } }) => {
  if (pathname) window.location.href = `joeapp:/${pathname}${search}`;
  return <p>Redirecting</p>;
};

export default LinkBankAccount;
